import { ComponentType as o } from "../../registries/types/propTypes.js";
import r from "../rich-text-component-transformer/richTextComponentTransformer.js";
const p = (n) => {
  const t = Array.isArray(n.banner_rich_text_component) ? n.banner_rich_text_component[0] : n.banner_rich_text_component, e = r(t);
  return delete e.sanitize, delete e.sanitizationConfig, {
    componentType: o.banner_rich_text_component,
    title: t.display_title,
    images: t.image.images.map((i) => ({
      url: i.image.url,
      altText: i.alt_text,
      viewport: i.viewport
    })),
    sanitize: t.sanitize ?? !1,
    sanitizationConfig: t.sanitizationConfig ?? {},
    richTextComponentData: e
  };
};
export {
  p as default
};
//# sourceMappingURL=banner-rich-text-transformer.js.map
